// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1e05W","title":"ClientReferral_title__H8GWH","itemText":"ClientReferral_itemText__1-NMV"};